import { SectionBorder } from "molecules/SectionBorder";
import { SmallHadding } from "molecules/SmallHeadding";
import { TitleHeading } from "molecules/TitleHeading";
import React from "react";
import { Container } from "react-bootstrap";

export const InnerBanner = (props) => {
  const defaultBanner = "media/inner-page-banner.png";
  const bannerSrc = props.image || props.bannerimg || defaultBanner;
  return (
    <>
      <section className="inner-page-banner  p-0" >
        <div className="container   pl-0 pr-0 " data-aos="fade-up"
     data-aos-duration="1500" 
     style={{display:'flex', alignItems:"flex-start",justifyContent:'center', flexDirection:'column', gap:'10px'}}>
          {/* <SmallHadding
            text={props.innertitle}
            className="mt-2  ef-gamon-font" 
            
            
          /> */}
              <div className="container mt-0 pl-0 pr-0">

          <h3 className="font-medium font76 m-0 mt-2  fontEb" style={{paddingBottom:'20px'}}>{props.innertitle}</h3>

            
          <SectionBorder className="bg-black" />
          </div>
          

        </div>

        <div className="container   pl-0 pr-0 py-0 ">
        
          <div className="inner-page-banner relative flex  my-3">
            <img
              src={bannerSrc}
              className="img-fluid relative m-0"
            />
            <div className="grid inner-banner-text">
              <div className="lg:col-7 md:col-10 sm:col-12">
                <h3 className="ef-gamon-font  text-white font-normal font3pc" >
                  {props.bannertext}
                </h3>
              </div>
            </div>
          </div>
         
        </div>
        <div className="container  py-0 pl-0 pr-0 borderSpacing">
          <SectionBorder className="" />
          </div>
      </section>
    </>
  );
};
